$('#modal-group-buy .modal-body .card').click(function() {
    var parent = $(this).closest('.modal-body');
    parent.find('.card.active').removeClass('active');
    parent.find('input[name=group_buy_type]').prop('checked', false);
    $(this).addClass('active');
    $(this).find('input[name=group_buy_type]').prop('checked', true);
});


$("#modal-group-buy .table-catalogs input[name=quantity]").change(function() {
    var val = $(this).val();
    if (val < 0) $(this).val(0);
    calcMoneyGroupBuy();
});

$("#modal-group-buy .table-catalogs .add-button").click(function () {
    var item = $(this).closest("tr");
    var quantity = item.find('input[name="quantity"]').val();
    quantity = quantity * 1;
    quantity += 1;
    item.find('input[name="quantity"]').val(quantity);
    calcMoneyGroupBuy();
});

$("#modal-group-buy .table-catalogs .sub-button").click(function () {
    var item = $(this).closest("tr");
    var quantity = item.find('input[name="quantity"]').val();
    quantity = quantity * 1;
    if (quantity == 0) return;
    quantity -= 1;
    item.find('input[name="quantity"]').val(quantity);
    calcMoneyGroupBuy();
});

var send_request = null;
function calcMoneyGroupBuy() {

    if (send_request) {
        send_request.abort();
        send_request = null;
    }

    var uuid = $('input[name=event_uuid]').val();
    var is_have_group_discount = $('input[name=is_have_group_discount]').length;

    let carts = {};
    let total_quantity = 0;
    let total_price = 0;

    $('#modal-group-buy .item-catalog').each(function() {
        var quantity = $(this).find('input[name=quantity]').val();
        var price = $(this).data("price") || 0;

        if (quantity && quantity > 0) {
            var id = $(this).data('id');
            carts[id] = quantity * 1;
            total_quantity += quantity;

            var temp = price * quantity;
            $(this).find('.sub-total').html(farm.formatMoney(temp));

            total_price += temp;
        } else {
            $(this).find('.sub-total').html(farm.formatMoney(0));
        }
    });

    if (!total_quantity || !is_have_group_discount) {
        $("#modal-group-buy .sub-total-group").addClass('d-none');
        $("#modal-group-buy .discount-group").addClass('d-none');
        $("#modal-group-buy .total-payment-group b").html(farm.formatMoney(total_price));

        if (total_quantity) {
            $("#modal-group-buy .btn-buy-now-group").removeClass("disabled");
        } else {
            $("#modal-group-buy .btn-buy-now-group").addClass("disabled");
        }

        return;
    }

    var data = {
        uuid: uuid,
        _token: CSRF_TOKEN,
        carts: carts
    };

    var url = APP_URL + '/api/crt/check-group-discount';

    send_request = $.post(url, data, function(res) {

        var total_payment = res.data.sub_total;

        if (res.data.discount_money) {
            total_payment -= res.data.discount_money;
            $("#modal-group-buy .sub-total-group").removeClass('d-none');
            $("#modal-group-buy .sub-total-group b").html(farm.formatMoney(res.data.sub_total));

            $("#modal-group-buy .discount-group").removeClass('d-none');
            $("#modal-group-buy .discount-group b").html('-' + farm.formatMoney(res.data.discount_money));

            if (res.data.discount_type == 'percent') {
                $("#modal-group-buy .discount-group .discount-title").html(' ('+ res.data.discount_value +'%)');
            }

        } else {
            $("#modal-group-buy .sub-total-group").addClass('d-none');
            $("#modal-group-buy .sub-total-group b").html('');

            $("#modal-group-buy .discount-group").addClass('d-none');
            $("#modal-group-buy .discount-group b").html('');
            $("#modal-group-buy .discount-group .discount-title").html('');
        }

        if (total_payment < 0) total_payment = 0;
        
        $("#modal-group-buy .total-payment-group b").html(farm.formatMoney(total_payment));
        $("#modal-group-buy .btn-buy-now-group").removeClass("disabled");

    }).fail(function(xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    });
}

$('#modal-group-buy .btn-buy-now-group').click(function() {

    hash_quantity = {};

    $('#modal-group-buy .item-catalog').each(function() {
        var quantity = $(this).find('input[name=quantity]').val();
        if (quantity && quantity > 0) {
            var id = $(this).data('id');
            hash_quantity[id] = quantity * 1;
        }
    });

    var data = {
        _token: CSRF_TOKEN,
        id: EVENT_UUID,
        join_code: JOIN_CODE,
        hash_quantity: hash_quantity
    };

    var url = APP_URL + '/api/crt/group-buy/init';

    $.LoadingOverlay('show');

    $.post(url, data, function(res) {
        window.location.href = res.data
    }).fail(function(xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    }).always(function() {
        $.LoadingOverlay("hide");
    });

});

$('#modal-group-buy .btn-collect-group').click(function() {

    var data = {
        id: EVENT_UUID,
        join_code: JOIN_CODE,
        _token: CSRF_TOKEN
    };

    var url = APP_URL + '/api/crt/group-collect/init';

    $.LoadingOverlay('show');

    $.post(url, data, function(res) {
        window.location.href = res.data
    }).fail(function(xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    }).always(function() {
        $.LoadingOverlay("hide");
    });

});